/**
 * Wind-down mode.
 *
 * AlphaFi is shutting down. While this flag is on, the app blocks every action
 * that puts more money in:
 *   - AlphaLend: Supply and Borrow
 *   - AlphaFi vaults: Deposit
 *   - ALPHA vault: Stake
 *   - stSUI: Stake
 *
 * Actions that take money out stay open: Withdraw, Repay, Unstake and reward
 * claims are untouched, so users can exit their positions.
 *
 * This is a UI block only. It stops the app from building the transaction, but
 * the contracts still accept these calls from anyone sending them directly.
 * Set this to `false` to turn the whole thing off again.
 */
export const IS_WIND_DOWN_ACTIVE = true;
/**
 * Plain-text copy for tooltips on paused supply/borrow buttons.
 */
export const WIND_DOWN_MESSAGE = 'Action needed: AlphaFi is winding down. Repay open loans and withdraw your assets. Withdrawals remain fully available.';
